import { render, staticRenderFns } from "./ModalFaceRating.vue?vue&type=template&id=1c3901d0&scoped=true&"
import script from "./ModalFaceRating.vue?vue&type=script&lang=js&"
export * from "./ModalFaceRating.vue?vue&type=script&lang=js&"
import style0 from "./ModalFaceRating.vue?vue&type=style&index=0&id=1c3901d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3901d0",
  null
  
)

export default component.exports